import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import QuickEntries from "@/pages/home/components/QuickEntries";
import LatestEpisodes from "@/pages/home/components/LatestEpisodes";
import HotInterpretations from "@/pages/home/components/HotInterpretations";
import SiteIntro from "@/pages/home/components/SiteIntro";

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader overlay />
      <main className="flex-1">
        <HeroCarousel />
        <QuickEntries />
        <LatestEpisodes />
        <HotInterpretations />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}